<app-loader-indicator></app-loader-indicator>
<div class="terms" [innerHTML]="htmlContent"></div>
